// extracted by mini-css-extract-plugin
module.exports = {"searchSection":"_NvAbJp_","mobile":"_2kacfxS","searchResult":"_2PpqWcp","resultList":"_SPCn-ET","article":"_FFk05B_","active":"_2Ax75CJ"};